import { ChangeEventHandler, VFC } from "react";
import { css } from "src/styles/theme";
import { SelectDataField } from "src/types/data-field.types";
import { NodeData } from "src/types/node.types";
import { FormField } from "../form-field";

export interface SelectFieldProps {
  field: SelectDataField;
  data: NodeData;
  onChange: (data: NodeData) => void;
}

export const SelectField: VFC<SelectFieldProps> = (props) => {
  const key = props.field.key;

  const onChangeHandler: ChangeEventHandler<HTMLSelectElement> = (e) => {
    props.onChange({ ...props.data, [key]: e.target.value });
  };

  const value = props.data[key] as string;

  return (
    <FormField.Field>
      <FormField.Label> {props.field.label}</FormField.Label>
      <FormField.Input>
        <select className={$select()} value={value} onChange={onChangeHandler}>
          {Object.entries(props.field.options).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </FormField.Input>
    </FormField.Field>
  );
};

const $select = css({
  applyReset: "input",
  width: 120,
  padding: "0 $2 0 0",
  border: 0,
  color: "$neutralText",
  fontSize: "$base",

  "&:focus": {
    outline: 0,
  },
});
